import {Decimal} from 'decimal.js';

import {NumberParsingFormat} from './NumberParsingFormat';

const IN_NUMBER_PATTERN = '#,##,##0.###'; // Indian numbering system (along with a few other locales) use group delimiters differently from the international norm (ex. 1,23,456.78)

export function localeAwareFormatNumber(
  numberToFormat: Decimal | number,
  numberParsingFormat: NumberParsingFormat,
  includeGroupDelimiter: boolean = true
): string {
  let formatted = numberToFormat.toString().replace('.', numberParsingFormat.decimalDelimiter);
  if (includeGroupDelimiter) {
    formatted = formatWithGroupDelimiters(formatted, numberParsingFormat);
  }
  return formatted;
}

function formatWithGroupDelimiters(
  formattedNumber: string,
  numberParsingFormat: NumberParsingFormat
): string {
  const decimalIndex = formattedNumber.includes(numberParsingFormat.decimalDelimiter)
    ? formattedNumber.indexOf(numberParsingFormat.decimalDelimiter)
    : formattedNumber.length;
  const integerPart = formattedNumber.slice(0, decimalIndex);
  const [leftGroupingLength, rightGroupingLength] = _findGroupings(numberParsingFormat.numberPattern);
  return (
    addGroupDelimiterToNumberString(
      integerPart,
      numberParsingFormat.groupDelimiter,
      leftGroupingLength,
      rightGroupingLength
    ) + formattedNumber.slice(decimalIndex)
  );
}

/**
 * Returns the group delimiter groupings for a number pattern
 * '#,##0.###' should return [3, 3]
 * '#,##,##0.###' should return [2, 3]
 */
export function _findGroupings(numberPattern: string): Array<number> {
  return numberPattern === IN_NUMBER_PATTERN ? [2, 3] : [3, 3];
}

function addGroupDelimiterToNumberString(
  formattedNumber: string,
  groupDelimiter: string,
  leftGroupingLength: number,
  rightGroupingLength: number | null = null
): string {
  const groupingLength = rightGroupingLength != null ? rightGroupingLength : leftGroupingLength;
  if (formattedNumber.length <= groupingLength) {
    return formattedNumber;
  }
  return (
    addGroupDelimiterToNumberString(
      formattedNumber.slice(0, -groupingLength),
      groupDelimiter,
      leftGroupingLength
    ) +
    groupDelimiter +
    formattedNumber.slice(-groupingLength)
  );
}
